import React from "react";
import { FiArrowUpRight } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import Features from "./Features";

const HomeBanner = () => {
  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem('Startuptoken');

  const handleRegisterClick = () => {
    if (isLoggedIn && isLoggedIn != "DEMO_TOKEN") {
      navigate('/startup-dashboard');
    } else {
      navigate('/startup-reg');
    }
  };

  const handleGuestLogin = () => {
    localStorage.setItem("Startuptoken", "DEMO_TOKEN");
    localStorage.setItem("startupId", "guest");
    localStorage.setItem("email", "guest@gmail.com");
    localStorage.setItem("startupName", "guest Mode");
    navigate("/startup-dashboard")

  }

  return (
    <div className="w-full">
      <div className="relative flex flex-col text-center px-4 md:px-10 pt-10 md:pt-3">

        {/* Top Content */}
       <div className="max-w-4xl w-full mx-auto z-10">
  <h1 className="text-3xl md:text-4xl font-bold text-gray-900 leading-snug lg:mt-8 flex items-center justify-center gap-3 flex-wrap">
    
    <img
      src="/tactosheading.png"
      alt=""
      className="inline-block h-9  object-contain"
    />

    <span className="block md:inline bg-gradient-to-r from-[#fd3e3d] via-[#f62828] to-[#fc1010] bg-clip-text text-transparent font-bold">
      The Startup Valley
    </span>
  </h1>

  {/* <p className="text-sm md:text-xl font-bold text-gray-600 mt-4">
    Are you ready? Register Now!
  </p> */}

  <div className="mt-6 flex gap-3 justify-center">
    <button
      onClick={handleRegisterClick}
      className="inline-flex items-center gap-2 bg-[#020c1b] hover:bg-[#0d1a2e] text-white text-sm md:text-base font-semibold py-2 px-6 rounded-full transition duration-200"
    >
      Register Now <FiArrowUpRight className="text-base text-[#fd3e3d]" />
    </button>

    {(isLoggedIn === "DEMO_TOKEN" || isLoggedIn === null) && (
      <button
        onClick={handleGuestLogin}
        className="inline-flex items-center gap-2 bg-[#020c1b] hover:bg-[#0d1a2e] text-white text-sm md:text-base font-semibold py-2 px-6 rounded-full transition duration-200"
      >
        Explore Tactos <FiArrowUpRight className="text-base text-[#fd3e3d]" />
      </button>
    )}
  </div>
</div>

        {/* Bottom Image with White Fade Effect */}
        <div className="relative w-full overflow-hidden">
          <img
            src="/new-bg.png"
            alt="Tamil Nadu Icons"
            className="w-full"
          />
          {/* Smoky Bottom Fade using Gradient */}
          <div className="absolute bottom-0 left-0 w-full h-4 md:h-10 bg-gradient-to-b from-transparent to-[#f9f7f6] pointer-events-none"></div>
        </div>

      </div>
    </div>
  );
};

export default HomeBanner;
